import { render, staticRenderFns } from "./ResDescModal.vue?vue&type=template&id=58a0c312&scoped=true&"
import script from "./ResDescModal.vue?vue&type=script&lang=js&"
export * from "./ResDescModal.vue?vue&type=script&lang=js&"
import style0 from "./ResDescModal.vue?vue&type=style&index=0&id=58a0c312&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a0c312",
  null
  
)

export default component.exports